import React from 'react';
import { string, func } from 'prop-types';
import RelativeVariableSummary from './RelativeVariableSummary';
import AbsoluteVariableSummary from './AbsoluteVariableSummary';
import { variableStatsType, variableTypeValues } from '../../constants/types';
import { getTranslation, withLang, langType } from '../../i18n';
import { replaceStudentPsychologistLink } from '../../util';

import styles from './variableSummary.module.css';
import SummaryExtraInfo from './SummaryExtraInfo';

const getChartForVariableStats = (stats, translate, lang, translatedVariableName) => {
  switch (stats.type) {
    case variableTypeValues.RELATIVE:
      return (
        <RelativeVariableSummary
          stats={stats}
          translate={translate}
          lang={lang}
          label={translatedVariableName}
        />
      );
    case variableTypeValues.ABSOLUTE:
      return (
        <AbsoluteVariableSummary
          stats={stats}
          translate={translate}
          lang={lang}
          label={translatedVariableName}
        />
      );
    default:
      return null;
  }
};

const getTitleForImprovementSuggestions = (stats, translate) => {
  switch (stats.type) {
    case variableTypeValues.ABSOLUTE:
      return translate('surveySummary.interpretation');
    default:
      return translate('surveySummary.improvementSuggestions');
  }
};

const VariableSummary = (props) => {
  const {
    lang, translate, previewLang, previewTranslate
  } = props;
  const {
    name,
    description,
    improvementSuggestions,
    variableExtraInfo
  } = props.stats;

  const selectedLanguage = previewLang || lang;
  const t = previewTranslate || translate;
  const translatedVariableName = getTranslation(name, selectedLanguage);
  const improvementSuggestionsHtml = replaceStudentPsychologistLink(improvementSuggestions, selectedLanguage);

  return (
    <section className={styles.section} data-cy="variable-summary">
      <h2>{translatedVariableName}</h2>
      <div className={styles.container}>
        <div className={styles.left}>
          { getChartForVariableStats(
            props.stats, t, selectedLanguage, translatedVariableName
          ) }
        </div>

        <div className={`${styles.right} textarea`}>
          <div
            dangerouslySetInnerHTML={// eslint-disable-line react/no-danger
              { __html: getTranslation(description, selectedLanguage) }
            }
          />
          { improvementSuggestionsHtml
            && <h3>{getTitleForImprovementSuggestions(props.stats, t)}</h3>}
          { improvementSuggestionsHtml
            && (
            <div
              dangerouslySetInnerHTML={// eslint-disable-line react/no-danger
                { __html: improvementSuggestionsHtml }
              }
            />
            )}
          {variableExtraInfo ? <SummaryExtraInfo variableExtraInfo={variableExtraInfo} /> : null}
        </div>
      </div>
    </section>
  );
};

VariableSummary.propTypes = {
  stats: variableStatsType.isRequired,
  previewTranslate: func, // eslint-disable-line react/require-default-props
  previewLang: string, // eslint-disable-line react/require-default-props
  ...langType
};

export default withLang(VariableSummary);
